export default __webpack_public_path__ + "static/seo-forsiden-7450ada47d3ab2b58dfaf06e3dedf808.png";